import { fadeIn } from './general';

export const animControllerHover = (props?: { delay?: number; staggerChildren?: number }) => ({
  initial: 'hoverInactive',
  whileHover: 'hoverActive',
  variants: {
    hoverInactive: {},
    hoverActive: {
      transition: {
        delay: props?.delay || 0,
        staggerChildren: props?.staggerChildren || 0.2,
      },
    },
  },
});

export const hoverFadeIn = {
  variants: {
    hoverInactive: fadeIn.variants.inactive,
    hoverActive: fadeIn.variants.active,
  },
};
